<template>
  <button type="button" class="bt-300">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Bt300"
}
</script>

<style scoped>
.bt-300  {
  width: 100px;
  padding: 5px 10px;
  font-size: medium;
  background-color: white;
  border-radius: 5px;
  border: 1px solid rgb(136, 136, 136);
  color: rgb(136, 136, 136);
  transition: 0.3s;
}

.bt-300:hover {
  color: white;
  background-color: var(--primary);
  transition: 0.3s;
  border: 1px solid white;
}
</style>